import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/components/LanguageContext";
import ScrollReveal from "@/components/ScrollReveal";
import { pathFor } from "@/data/pages";

// PwC-style lead-gen CTA — split layout, image background on the right.
export default function LeadCTA() {
  const { lang, t } = useLang();
  const heading = lang === "zh"
    ? "让我们一起，让它发生。"
    : "Together, let's make it happen.";
  const body = lang === "zh"
    ? "无论是创业初期、扩张阶段还是退休规划——我们的注册税务代理、CPA 与 SMSF 专家随时为您服务。"
    : "Whether you're starting, scaling or planning retirement — our registered tax agents, CPAs and SMSF specialists are ready to help.";
  const cta = lang === "zh" ? "预约免费 15 分钟咨询" : "Book a free 15-min consultation";

  return (
    <section className="relative overflow-hidden" data-testid="lead-cta">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[520px]">
        {/* Left — copy */}
        <div className="bg-[var(--abs-ink)] text-white flex items-center">
          <div className="max-w-xl px-6 lg:px-16 py-20 lg:py-28">
            <ScrollReveal>
              <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--abs-orange)] mb-6">
                {lang === "zh" ? "联系我们" : "Get in touch"}
              </div>
              <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.04] mb-7">{heading}</h2>
              <p className="text-white/75 text-[16.5px] leading-[1.7] max-w-md mb-9">{body}</p>
              <Link
                to={pathFor("contact", lang)}
                data-testid="lead-cta-btn"
                className="inline-flex items-center gap-3 bg-white text-[var(--abs-ink)] px-7 py-4 hover:bg-[var(--abs-orange)] hover:text-white transition-colors"
              >
                <span className="text-[15px] font-medium">{cta}</span>
                <ArrowRight className="h-4 w-4" />
              </Link>
            </ScrollReveal>
          </div>
        </div>

        {/* Right — image with orange parallelogram overlay */}
        <div className="relative bg-[#1a1814] min-h-[300px]">
          <img
            src="/images/stock/1521737711867.jpg"
            alt="Australian business consultants reviewing strategy"
            className="absolute inset-0 w-full h-full object-cover opacity-90"
          />
          <div
            className="absolute z-10"
            style={{
              left: "10%",
              bottom: "18%",
              width: "70%",
              height: "30%",
              background: "var(--abs-orange)",
              transform: "skewY(-6deg)",
              mixBlendMode: "multiply",
            }}
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
}
